import http from 'utils/http';

export const fetchGeneralReport = (query) => http.get(`v1/organizations/{{organizationId}}/reporting/general/?${query}`).then((res) => res.data);
